import React, { memo } from "react";

import AccountsPayableReceivableReport from "../AccountsPayableReceivableReport";

const AccountReceivableReport = () => {
  return <AccountsPayableReceivableReport accountCode="1500" />;
};

export default memo(AccountReceivableReport);
